module.exports = __webpack_public_path__ + "static/img/jpwjh5.9e68677.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpwjh5.png
// module id = +HpF
// module chunks = 0